module.exports = __webpack_public_path__ + "img/water-meter-cold-sm.4d757c2f.svg";